import Layout from '@layout/Index'

export const paymentApprovalNew = [
  {
    path: '/payment-approval-new',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "payment-approval-new-table" */ './pages/PaymentApprovalTable.vue'),
        meta: {
          title: '付款审批列表',
        },
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "payment-approval-new-form" */ './pages/PaymentApprovalForm.vue'),
        meta: {
          title: '添加付款审批',
        },
      },
      {
        path: 'update/:id',
        component: () => import(/* webpackChunkName: "payment-approval-new-form" */ './pages/PaymentApprovalForm.vue'),
        meta: {
          title: '修改付款审批',
        },
      },
      {
        path: 'review/:id',
        component: () => import(/* webpackChunkName: "payment-manager-new-review" */ './pages/PaymentApprovalReview.vue'),
        meta: {
          isReview: true,
          isApproval: true,
          title: '付款申请详情',
        },
      },
      {
        // 退款
        path: 'refund/:id',
        component: () => import(/* webpackChunkName: "payment-manager-new-review" */ './pages/PaymentApprovalReview.vue'),
        meta: {
          isRefund: true,
          isReview: true,
          isApproval: true,
          title: '付款申请详情',
        },
      },
      {
        path: 'detail/:id',
        component: () => import(/* webpackChunkName: "payment-approval-new-detail" */ '@views/payment-manager-new/pages/PaymentManagerReview.vue'),
        meta: {
          isApproval: true,
          showConfirmAmount: true,
          title: '付款审批详情',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/payment-approval-new/payment-approval.route.js